import { render } from "./Player.vue?vue&type=template&id=24629859"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__